import type { HTMLAttributes, ReactNode } from "react"
import { cn } from "../../lib/cn"

export type StatusPillVariant = "neutral" | "success" | "warning" | "danger" | "accent"

const variantClasses: Record<StatusPillVariant, string> = {
  neutral: "bg-surface-muted text-text-secondary",
  success: "bg-success/10 text-success",
  warning: "bg-accent/10 text-accent",
  danger: "bg-danger/10 text-danger",
  accent: "bg-accent/10 text-accent",
}

export interface StatusPillProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: StatusPillVariant
  children: ReactNode
}

export function StatusPill({ variant = "neutral", className, children, ...props }: StatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2xs rounded-badge px-sm py-2xs text-caption font-semibold",
        variantClasses[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}

export const Badge = StatusPill
